import { useCallback, useEffect, useState } from "react";

//Internal Imports
import './ListadoHistorico.css';
import MenuLayout from "../../common/components/MenuLayout/MenuLayout";
import SearchText from "../../common/components/SearchText/SearchText";
import SurveyItem from "../../common/components/SurveyItem/SurveyItem";
import { COLORS } from "../../common/constants/colors";
import { IMenu } from "../../interfaces/IMenu";
import { IPropsMenu } from "../../interfaces/IPropsMenu";
import { GetFormsHistoric, GetFormsHistoricByDates, GetSurvey } from "../../services/survey";
import { TypeVisualization } from "../../interfaces/IForm";
import { VisualizacionFormulario } from "../../common/enums/AllEnums";
import Paint from "../../common/components/Paint/Paint";
import EntidadEncuestaItem from "../../common/components/EntidadEncuestaItem/EntidadEncuestaItem";
import Item from "antd/lib/list/Item";
import { useNavigate } from "react-router-dom";
import { IAnswer } from "../../interfaces/IAnswer";
import AnswerItem from "../../common/components/AnswerItem/AnswerItem";
import { useForm } from "../../contexts/form";
import { openNotification, tryCatch } from "../../common/constants/Utilities";
import LabelNotFound from "../../common/components/Label/LabelNotFound";
import LoadingPage from "../../common/components/LoadingPage/LoadingPage";
import { useAuth } from "../../contexts/auth";
import DatePicker from "antd/lib/date-picker";
import moment from "moment";
import LoadingButton from "../../common/components/LoadingButton/LoadingButton";





const ListadoHistoricoAvanzado: React.FC<IPropsMenu> = ({ menu }) => {
    const { userInformation } = useAuth();
    const [searchV, setSearchV] = useState<string>('');
    const [listAnswer, setlistAnswer] = useState<IAnswer[]>([]);
    const { answerEntitySelected, setAnswerEntitySelected } = useForm();
    const [formLoading, setFormLoading] = useState<boolean>(false);
    const [dateMinFilter, setDateMinFilter] = useState<any>();
    const [dateMaxFilter, setDateMaxFilter] = useState<any>();
    const [viewError, setViewError] = useState<boolean>(false);

    //Method
    const getListSurveysFiltered = useCallback(() => {
        let surveysFiltered: IAnswer[] = [];
        const valueLowerCase = searchV.toLowerCase();

        if (!!valueLowerCase) {
            surveysFiltered = listAnswer.filter((list) =>
                list.nombre?.toLowerCase().includes(valueLowerCase))
        } else {
            surveysFiltered = listAnswer
        }

        return surveysFiltered;
    }, [searchV, listAnswer])

    //Method
    const goToEntitySurveided = (FormAnsweredID: number) => {

        setAnswerEntitySelected({
            ...answerEntitySelected,
            formId: FormAnsweredID,
            fechaDesde: dateMinFilter,
            fechaHasta: dateMaxFilter,
            formName: getListSurveysFiltered().find(x => x.formularioID === FormAnsweredID)?.nombre,
            listadoNombre: getListSurveysFiltered().find(x => x.formularioID === FormAnsweredID)?.listadoNombre
        });
        navigate(`/HistoricoEntidadAvanzada`);
    }

    const onSubmit = () => {
        if (!!lookForError().Minima || !!lookForError().Maxima) {
            setViewError(true);
            setlistAnswer([]);
        } else {
            getListHistoricByDates();
        }

    }

    const lookForError = () => {
        let fechas = { Minima: "", Maxima: "" };
        !dateMinFilter && (fechas.Minima = "Debe de selecionar una fecha mínima.");
        !dateMaxFilter && (fechas.Maxima = "Debe de selecionar una fecha maxima.");
        return fechas;
    }
    const getListHistoricByDates = () => {
        tryCatch(() => {
            setFormLoading(true);
            GetFormsHistoricByDates(!!dateMinFilter ? dateMinFilter : answerEntitySelected?.fechaDesde, !!dateMaxFilter ? dateMaxFilter : answerEntitySelected?.fechaHasta).then(response => {
                setlistAnswer(response.data)

            })
                .catch((response) => {
                    openNotification('error', 'Error', !!response?.msg ? response.msg : 'Contáctese con el equipo Bis para más información.');
                })
                .finally(() => setFormLoading(false));
        })
    }
    const handleDateBoxMin = (date: any, dateString: any) => { setDateMinFilter(dateString.toString()); } // Date
    const handleDateBoxMax = (date: any, dateString: any) => { setDateMaxFilter(dateString.toString()); } // Date
    const navigate = useNavigate();

    useEffect(() => {
        if (!!answerEntitySelected?.fechaDesde && !!answerEntitySelected?.fechaHasta) {

            setDateMinFilter(answerEntitySelected?.fechaDesde);
            setDateMaxFilter(answerEntitySelected?.fechaHasta);
            getListHistoricByDates();
        }
    }, []);


    return (

        <MenuLayout currentPage={menu.nombre}>
            <div className="listAnswer_container">
                <div className="filter-bar">
                    <div>
                        <DatePicker value={!!dateMinFilter ? moment(dateMinFilter) : null} placeholder='Fecha desde.' onChange={handleDateBoxMin} />
                        {(viewError && !dateMinFilter) && <p className="ContainerBox-body-middle-error">{lookForError().Minima}</p>}
                    </div>
                    <div>
                        <DatePicker value={!!dateMaxFilter ? moment(dateMaxFilter) : null} placeholder='Fecha hasta.' onChange={handleDateBoxMax} />
                        {(viewError && !dateMaxFilter) && <p className="ContainerBox-body-middle-error">{lookForError().Maxima}</p>}
                    </div>

                    <LoadingButton classname={"btn-filtrar"} title={"Filtrar"} background={COLORS.blue_active} color={COLORS.white_color1} loading={"false"} method={() => onSubmit()} fontsize={20} type={'button'} />
                    <div>
                        <SearchText
                            value={searchV}
                            active={true}
                            borderColor={COLORS.black_back_color5}
                            textColor={COLORS.black_text_color1}
                            placeholdercolor={COLORS.black_text_color4}
                            name={"search_table"}
                            onChange={setSearchV}
                            placeholder={"Buscar"}
                            backgroundcolor={COLORS.black_back_color5}
                            opacity={1}
                            props={{ collapsed: 'false' }}
                        />
                    </div>

                </div>


                <div className="listAnswer_sesion" style={{height: '530px', overflowY:'auto', padding:'10px'}}>
                    
                    {formLoading.toString() === 'true'
                        ? <div className="loading-container"> <LoadingPage message="Cargando..." /></div>
                        : getListSurveysFiltered().length === 0 && <div className="loading-container"> <LabelNotFound message="No se encontró la busqueda." /></div>

                    }
                    {getListSurveysFiltered().map((answer: IAnswer) =>
                        <AnswerItem
                            active={true}
                            backgroundcolorheader={COLORS.blue_inactive(1)}
                            backgroundcolorbody={COLORS.blue_inactive(1)}
                            item={answer}
                            borderColor={COLORS.black_shadow_1}
                            props={{ collapsed: 'false' }}
                            textColor={COLORS.blue_main(1)}
                            method={() => goToEntitySurveided(answer.formularioID)}
                        />
                    )
                    }
                </div>
            </div>
        </MenuLayout>
    )
}

export default ListadoHistoricoAvanzado;